import { render, staticRenderFns } from "./ParametrosAccion.vue?vue&type=template&id=4478b511&scoped=true"
import script from "./ParametrosAccion.vue?vue&type=script&lang=js"
export * from "./ParametrosAccion.vue?vue&type=script&lang=js"
import style0 from "./ParametrosAccion.vue?vue&type=style&index=0&id=4478b511&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478b511",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4478b511')) {
      api.createRecord('4478b511', component.options)
    } else {
      api.reload('4478b511', component.options)
    }
    module.hot.accept("./ParametrosAccion.vue?vue&type=template&id=4478b511&scoped=true", function () {
      api.rerender('4478b511', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/ParametrosAccion.vue"
export default component.exports